import { render, staticRenderFns } from "./ChangeTempPasswordByUniqueLink.vue?vue&type=template&id=f7634cfa&scoped=true&"
import script from "./ChangeTempPasswordByUniqueLink.vue?vue&type=script&lang=js&"
export * from "./ChangeTempPasswordByUniqueLink.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTempPasswordByUniqueLink.vue?vue&type=style&index=0&id=f7634cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7634cfa",
  null
  
)

/* custom blocks */
import block0 from "./ChangeTempPasswordByUniqueLink.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./ChangeTempPasswordByUniqueLink.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardTitle,VForm,VTextField})
